"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhysicsSettings = void 0;
function load(data) {
    PhysicsSettings.mcData = data;
    PhysicsSettings.entityData = data["entitiesByName"];
    PhysicsSettings.mobData = data["mobs"];
}
class PhysicsSettings {
}
exports.PhysicsSettings = PhysicsSettings;
PhysicsSettings.loadData = load;
PhysicsSettings.yawSpeed = 3.0;
PhysicsSettings.pitchSpeed = 3.0;
PhysicsSettings.playerSpeed = 0.1;
PhysicsSettings.stepHeight = 0.6; // how much height can the bot step on without jump
PhysicsSettings.negligeableVelocity = 0.003; // actually 0.005 for 1.8; but seems fine
PhysicsSettings.soulsandSpeed = 0.4;
PhysicsSettings.honeyblockSpeed = 0.4;
PhysicsSettings.honeyblockJumpSpeed = 0.4;
PhysicsSettings.ladderMaxSpeed = 0.15;
PhysicsSettings.ladderClimbSpeed = 0.2;
PhysicsSettings.waterInertia = 0.8;
PhysicsSettings.lavaInertia = 0.5;
PhysicsSettings.liquidAcceleration = 0.02;
PhysicsSettings.defaultSlipperiness = 0.6;
PhysicsSettings.outOfLiquidImpulse = 0.3;
PhysicsSettings.autojumpCooldown = 10; // ticks (0.5s)
PhysicsSettings.bubbleColumnSurfaceDrag = {
    down: 0.03,
    maxDown: -0.9,
    up: 0.1,
    maxUp: 1.8,
};
PhysicsSettings.bubbleColumnDrag = {
    down: 0.03,
    maxDown: -0.3,
    up: 0.06,
    maxUp: 0.7,
};
PhysicsSettings.slowFalling = 0.125;
PhysicsSettings.sprintingUUID = "662a6b8d-da3e-4c1c-8813-96ea6097278d"; // SPEED_MODIFIER_SPRINTING_UUID is from LivingEntity.java
PhysicsSettings.jumpHeight = Math.fround(0.42);
PhysicsSettings.airborneInertia = 0.99;
PhysicsSettings.airborneAcceleration = 0.06;
PhysicsSettings.sprintSpeed = Math.fround(0.3);
PhysicsSettings.sneakSpeed = 0.3;
PhysicsSettings.usingItemSpeed = 0.2;
